import {mapGetters} from "vuex";

export default {
    name: 'main-footer',
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            currentCountry: 'setting/currentCountry',
            setting: 'setting/setting',
        }),
        shopLink() {
            return this.setting && this.setting.storeLink ? this.setting.storeLink : 'https://genius.space/nashi-programmy-obucheniya/';
        },
        mailtoLink() {
            return 'mailto:' + this.$t('contactsEmailLink');
        },
        tgBotLink() {
            return 'https://t.me/' + this.$t('contactsTelegramBotLink');
        },
    },
}
